import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import InnerFrame from "../shared/InnerFrame";

const evaluationStandards = [
  {
    levelLabel: "S",
    developmentDescription: "開発エンジニア：テックリードレベル",
    infrastructureDescription: "インフラエンジニア：アーキテクトレベル",
  },
  {
    levelLabel: "A",
    developmentDescription: "開発エンジニア：独自遂行・レビューができる",
    infrastructureDescription:
      "インフラエンジニア：高度な構築や運用が可能でレビューもできる",
  },
  {
    levelLabel: "B",
    developmentDescription: "開発エンジニア：一部調べながらでも独自遂行できる",
    infrastructureDescription:
      "インフラエンジニア：一部調べながらでも構築・運用を独自遂行できる",
  },
  {
    levelLabel: "C",
    developmentDescription:
      "開発エンジニア：有識者のサポートがあればある程度遂行できる",
    infrastructureDescription:
      "インフラエンジニア：有識者のサポートがあれば構築・運用が可能",
  },
  {
    levelLabel: "D",
    commonDescription: "基本的な知識はあるがOJTが必要 / 実務での経験はなし",
  },
];

function EvaluationStandardCard({ standard, isDesktop }) {
  return (
    <InnerFrame sx={{ p: "16px" }}>
      <Typography sx={{ fontWeight: "bold", fontSize: isDesktop ? 18 : 14 }}>
        評価レベル：【{standard.levelLabel}】
      </Typography>

      {standard.commonDescription ? (
        <Typography
          sx={{ color: "text.secondary", fontSize: isDesktop ? 14 : 12 }}
        >
          {standard.commonDescription}
        </Typography>
      ) : (
        <Box>
          <Typography
            sx={{ color: "text.secondary", fontSize: isDesktop ? 14 : 12 }}
          >
            {standard.developmentDescription}
          </Typography>
          <Typography
            sx={{ color: "text.secondary", fontSize: isDesktop ? 14 : 12 }}
          >
            {standard.infrastructureDescription}
          </Typography>
        </Box>
      )}
    </InnerFrame>
  );
}

export default function EvaluationStandardsSection({ isDesktop }) {
  return (
    <>
      <Box>
        <Grid container spacing={2}>
          {evaluationStandards.map((standard) => (
            <Grid
              item
              xs={12}
              sm={isDesktop ? 6 : 12}
              key={standard.levelLabel}
            >
              <EvaluationStandardCard
                standard={standard}
                isDesktop={isDesktop}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}
